const CopyIcon = () => {
    return (
        <svg width="17px" height="18px" viewBox="0 0 17 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>Group 7</title>
            <g id="PathPilotApp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PPDesktopChatHistory1920" transform="translate(-802, -966)" stroke="#6C7275" strokeWidth="2">
                    <g id="Group18" transform="translate(803, 961)">
                        <g id="Group16" transform="translate(0, 0)">
                            <g id="Group7" transform="translate(-0, 6.0003)">
                                <path d="M13.0402,11.922 L5.6972,11.922 C4.8652,11.922 4.1912,11.262 4.1912,10.448 L4.1912,1.473 C4.1912,0.659 4.8652,-2.27373675e-13 5.6972,-2.27373675e-13 L9.7542,-2.27373675e-13 C10.0962,-2.27373675e-13 10.4282,0.114 10.6952,0.323 L13.9812,2.896 C14.3382,3.175 14.5462,3.599 14.5462,4.046 L14.5462,10.448 C14.5462,11.262 13.8722,11.922 13.0402,11.922 Z" id="Stroke1"></path>
                                <path d="M10.964,11.922 L10.964,14.073 C10.964,14.887 10.29,15.547 9.458,15.547 L1.506,15.547 C0.675,15.547 0,14.887 0,14.073 L0,5.098 C0,4.284 0.675,3.624 1.506,3.624 L4.191,3.624" id="Stroke5"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default CopyIcon;
